(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8416],{

/***/ 60:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carpetlook",
      function () {
        return __webpack_require__(73751);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35005);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46737);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(sweetalert__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61120);
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(html2canvas__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var jspdf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91819);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6154);









function TileReplacementModal(param) {
    let { isOpen , onClose , onReplace , setImgUrl , setTileReplacement , tilesUsed , setTilesUsed , newImg , setNewImg  } = param;
    const limit = 200;
    // Initialize keywordSuggestions as an empty array
    const [keywordSuggestions, setkeywordSuggestions] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [searchText, setSearchText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const getfeeds = async (e)=>{
        setSearchText(e.target.value);
        try {
            const resp = await axios__WEBPACK_IMPORTED_MODULE_7__/* ["default"].get */ .Z.get("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/autosuggest?q=".concat(e.target.value, "&topQueries.count=0&popularProducts.count=").concat(limit, "&inFields.count=3&popularProducts.fields=price%2CproductUrl%2CimageUrl%2Ctitle%2CtileSize&promotedSuggestion.count=0&asd=asd"));
            if (resp.status === 200) {
                // Ensure the response products are an array
                setkeywordSuggestions(resp.data.response.products || []);
                console.log(resp.data.response.products);
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: "carpetlook-product-popup",
        show: isOpen,
        onHide: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Header */ .Z.Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Title */ .Z.Title, {
                    children: "Search Product"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Body */ .Z.Body, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "text",
                        className: "search-input",
                        "aria-label": "Search Box",
                        value: searchText,
                        placeholder: "Search Products",
                        onChange: getfeeds
                    }),
                    keywordSuggestions.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "page-wrapper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "obl-experience-section auto-search-bar",
                            onClick: ()=>setkeywordSuggestions([]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "auto-search-row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "search-col-right",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "aa-dataset-products",
                                            children: keywordSuggestions.filter((item)=>item.title).length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: "No products found."
                                            }) : keywordSuggestions.filter((item)=>item.title).map((obj, index)=>{
                                                var ref;
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "search-products-col",
                                                    onClick: ()=>{
                                                        // Use the first image from the imageUrl array for replacement
                                                        const selectedImage = obj.imageUrl[0];
                                                        setImgUrl([
                                                            selectedImage
                                                        ]);
                                                        setNewImg([
                                                            selectedImage
                                                        ]);
                                                        setTileReplacement(false);
                                                        setkeywordSuggestions([]);
                                                        setSearchText("");
                                                        onReplace(obj);
                                                        setTilesUsed(obj);
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "thumb",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: (obj === null || obj === void 0 ? void 0 : (ref = obj.imageUrl) === null || ref === void 0 ? void 0 : ref.length) ? obj.imageUrl[0] : "",
                                                                    alt: obj.title
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "info",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: obj.title
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
function Carpetlook() {
    const [groutApplied, setGroutApplied] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    const [rows, setRows] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(6);
    const [cols, setCols] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(6);
    const [rowsInGrid, setRowsInGrid] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(6);
    const [colsInGrid, setColsInGrid] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(6);
    const [rotations, setRotations] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [tileReplacement, setTileReplacement] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [totalTiles, setTolalTiles] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    const [rowvalErr, setRowValErr] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [colvalErr, setColValErr] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [selectedTilesForReplacement, setSelectedTilesForReplacement] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [isModalOpen, setIsModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [imgUrl, setImgUrl] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [previewModalOpen, setPreviewModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [tilesUsed, setTilesUsed] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [replacedTiles, setReplacedTiles] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const [pdtImg, setPdtImg] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(router.query.img);
    const [pdtSku, setPdtSku] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [printPreviewOpen, setPrintPreviewOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const printContentRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const [newImg, setNewImg] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        let totalTilesInGrid = rowsInGrid * colsInGrid;
        setTolalTiles(totalTilesInGrid);
    }, [
        rowsInGrid,
        colsInGrid
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const imgParam = router.query.img;
        setPdtImg(imgParam);
        console.log("Current path:", router.asPath);
    }, [
        router.query.img
    ]);
    const rotateImage = (index)=>{
        setRotations((prevRotations)=>{
            const newRotations = [
                ...prevRotations
            ];
            newRotations[index] = (newRotations[index] || 0) + 90;
            return newRotations;
        });
    };
    const handleTileReplacement = (index)=>{
        setSelectedTilesForReplacement((prevSelectedTiles)=>{
            if (prevSelectedTiles.includes(index)) {
                const updatedReplacedTiles = {
                    ...replacedTiles
                };
                updatedReplacedTiles[index] = newImg[newImg.length - 1];
                setReplacedTiles(updatedReplacedTiles);
                return prevSelectedTiles.filter((selectedTile)=>selectedTile !== index);
            } else {
                return [
                    ...prevSelectedTiles,
                    index
                ];
            }
        });
    };
    const openModal = ()=>{
        setIsModalOpen(true);
    };
    const closeModal = ()=>{
        setIsModalOpen(false);
    };
    const onPreviewClose = ()=>{
        setPreviewModalOpen(false);
    };
    const closePrintPreview = ()=>{
        setPrintPreviewOpen(false);
    };
    const replaceTile = ()=>{
        // Replace logic can be expanded if needed
        selectedTilesForReplacement.forEach((tile)=>{
        // Here you can add logic for each selected tile if needed
        });
    };
    const handleReplaceButtonClick = async ()=>{
        if (selectedTilesForReplacement.length === 0) {
            sweetalert__WEBPACK_IMPORTED_MODULE_3___default()("Please select at least one tile image to swap");
        } else {
            openModal();
        }
    };
    function download(dataUrl, filename) {
        const a = document.createElement("a");
        a.href = dataUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    // Function to download the grid as an image
    const handleDownload = async ()=>{
        setPreviewModalOpen(true);
        setTimeout(()=>{
            const modalNode = document.getElementById("preview-modal");
            html2canvas__WEBPACK_IMPORTED_MODULE_4___default()(modalNode).then((canvas)=>{
                const dataUrl = canvas.toDataURL("image/png");
                download(dataUrl, "grid_preview.png");
                setPreviewModalOpen(false);
            });
        }, 2000);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (rows > 6) {
            setRowValErr("Rows cannot be more than 6");
            setTimeout(()=>setRowValErr(""), 4000);
        }
        if (rows < 1) {
            setRowValErr("At least one row is needed");
            setTimeout(()=>setRowValErr(""), 4000);
        }
        if (cols > 6) {
            setColValErr("Columns cannot be more than 6");
            setTimeout(()=>setColValErr(""), 4000);
        }
        if (cols < 1) {
            setColValErr("At least one column is needed");
            setTimeout(()=>setColValErr(""), 4000);
        }
        if (!rowvalErr && !colvalErr) {
            setRowsInGrid(rows);
            setColsInGrid(cols);
            setRotations([]);
        }
    };
    const renderTileGrid = ()=>{
        return Array.from({
            length: rowsInGrid
        }, (_, rowIndex)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: Array.from({
                    length: colsInGrid
                }, (_, colIndex)=>{
                    const tileIndex = rowIndex * colsInGrid + colIndex;
                    const isSelectedForReplacement = selectedTilesForReplacement.includes(tileIndex);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat(rowIndex).concat(colIndex),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: router.asPath === "/carpetlook" ? "carpet-look-default.avif" : isSelectedForReplacement && newImg.length > 0 ? newImg[newImg.length - 1] : replacedTiles[tileIndex] || pdtImg,
                                    alt: "New tile image",
                                    className: groutApplied ? "withGroutBorder" : "",
                                    style: {
                                        transform: "rotate(".concat(rotations[tileIndex] || 0, "deg)")
                                    },
                                    onClick: ()=>rotateImage(tileIndex)
                                }),
                                tileReplacement && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "checkbox",
                                    onChange: ()=>handleTileReplacement(tileIndex),
                                    checked: isSelectedForReplacement
                                })
                            ]
                        })
                    }, colIndex);
                })
            }, rowIndex));
    };
    const handlePrintButtonClick = ()=>{
        const printWindow = window.open("", "_blank");
        printWindow.document.title = "Print Message";
        const templateContent = document.createElement("div");
        templateContent.innerHTML = document.getElementsByClassName("img-section")[0].innerHTML;
        printWindow.document.body.appendChild(templateContent);
        printWindow.print();
        printWindow.close();
    };
    const printModalContent = ()=>{
        const content = document.getElementById("preview-modal");
        if (content) {
            const pdf = new jspdf__WEBPACK_IMPORTED_MODULE_5__/* .jsPDF */ .kH();
            pdf.html(content, {
                callback: ()=>{
                    pdf.save("carpetlook.pdf");
                    setPreviewModalOpen(false);
                }
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Try Different Laying patterns | Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "Try Different Laying patterns | Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Orientbell Carpet look helps visualize the tiles in different laying patterns and combinations."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "carpet_looks",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "carpet-left-sec",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: "Trying different laying patterns"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Carpet look helps visualize the tiles in different laying patterns and combinations."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tile-used-section",
                                    children: [
                                        tilesUsed.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                            children: "Tiles Used"
                                        }),
                                        tilesUsed.length > 0 && tilesUsed.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                className: "tiles_added",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: item
                                                })
                                            }, index))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "dynamic-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "carpet-logo",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "CarpetlookLogo.jpg",
                                        alt: "Carpet Look Logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                    className: "tilecalculation",
                                    id: "tilecalculation",
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "grout",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: !groutApplied,
                                                    onChange: ()=>setGroutApplied(!groutApplied)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    children: "Select to remove the grout between the tiles"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "img-section",
                                            children: rowsInGrid > 0 && rowsInGrid < 7 && colsInGrid > 0 && colsInGrid < 7 && renderTileGrid()
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "replace-tile",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: tileReplacement,
                                                    onChange: ()=>setTileReplacement(!tileReplacement)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    children: "Select the tile to be replaced with another tile"
                                                }),
                                                tileReplacement && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    onClick: handleReplaceButtonClick,
                                                    children: "Click to Replace Tile"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TileReplacementModal, {
                                                    isOpen: isModalOpen,
                                                    onClose: closeModal,
                                                    onReplace: replaceTile,
                                                    setImgUrl: setImgUrl,
                                                    setTileReplacement: setTileReplacement,
                                                    tilesUsed: tilesUsed,
                                                    setTilesUsed: setTilesUsed,
                                                    newImg: newImg,
                                                    setNewImg: setNewImg
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "measurement",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                            children: "Number of rows*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "number",
                                                            name: "rows",
                                                            value: rows,
                                                            onChange: (e)=>setRows(e.target.value),
                                                            required: true
                                                        }),
                                                        rowvalErr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "error text-danger",
                                                            children: rowvalErr
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                            children: "Number of columns*"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "number",
                                                            name: "cols",
                                                            value: cols,
                                                            onChange: (e)=>setCols(e.target.value),
                                                            required: true
                                                        }),
                                                        colvalErr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "error text-danger",
                                                            children: colvalErr
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "measurement-button",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                type: "submit",
                                                onClick: handleSubmit,
                                                children: "Submit"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "note",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                        children: "Note: Use of Spacer is strongly recommended for laying tiles"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "carpet-sec-right",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "carpet-sec-button-bx",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                onClick: ()=>setPreviewModalOpen(true),
                                                children: "Preview"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://wa.me/918750733333?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: "whatsapp.svg",
                                                        alt: "Icon"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                onClick: handleDownload,
                                                children: "Download"
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: "carpetlook-product-popup",
                            id: "preview-modal",
                            show: previewModalOpen,
                            onHide: onPreviewClose,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Header */ .Z.Header, {
                                    closeButton: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Body */ .Z.Body, {
                                    children: renderTileGrid()
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Carpetlook);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7847,5443,4585,6212,6737,2449,9774,2888,179], function() { return __webpack_exec__(60); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);